import { render, staticRenderFns } from "./MediacontactRegionCreate.vue?vue&type=template&id=50fa744a"
import script from "./MediacontactRegionCreate.vue?vue&type=script&lang=js"
export * from "./MediacontactRegionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports